<template>
  <div class="homeWrap mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center; margin-top: 0">
      <div class="text1">实验室安全生态</div>
      <div class="text2">预防 - 监控 - 处置 - 追溯</div>
    </div>
    <div class="wow animate__animated animate__fadeIn display-flex">
      <OssImg
        class="EcologicalImg"
        src="/UIV3/ecology.png"
        alt=""
        fit="contain"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
</script>

<style lang="scss" scoped>
.EcologicalImg {
  width: 70%;
  margin: auto;
}
</style>
